<template>
    <div class="pagination-old clearfix">
        <div class="pagination__items clearfix">
            <span class="pagination__items__label">{{ $t('paginator.itemsPerPage') }}</span>
            <el-select :value="perPage" class="pagination__items__select" @change="onChange">
                <el-option v-for="value in perPageList" :key="value" :label="value" :value="value"> </el-option>
            </el-select>
            <span class="pagination__items__result">| {{ $t('paginator.showItems', { from, to, total }) }}</span>
        </div>
        <div class="pagination-old__paginator mt-3 mt-sm-0">
            <ul class="clearfix mb-0">
                <li @click="prev()">
                    <a href="javascript:void(0)" class="box-left" :class="{ disabled: page === 1 }">
                        <i class="el-icon-d-arrow-left"></i>
                    </a>
                </li>
                <li v-for="(page, index) in pageList" :key="index" :class="page.class" @click="goPage(page)">
                    <a href="javascript:void(0)">
                        {{ page.value }}
                    </a>
                </li>
                <li @click="next()">
                    <a href="javascript:void(0)" class="box-right" :class="{ disabled: page === totalPage }">
                        <i class="el-icon-d-arrow-right"></i>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { PER_PAGE_LIST } from '@/config/constants';
// Component create common pagination
export default {
    name: 'pagination',
    props: {
        total: {
            type: Number,
            require: true
        },
        page: {
            type: Number,
            require: true
        },
        perPage: {
            type: Number,
            require: true
        }
    },

    data: function () {
        return {
            perPageList: PER_PAGE_LIST
        };
    },
    methods: {
        goPage(page) {
            if (page.class !== 'dot' && page.class !== 'active') {
                this.$emit('update:page', page.value);
                window.scrollTo(0, 0);
            }
        },
        prev() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (this.page > 1) {
                    this.$emit('update:page', this.page - 1);
                    window.scrollTo(0, 0);
                }
            }, 500);
        },
        next() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (this.page < this.totalPage) {
                    this.$emit('update:page', this.page + 1);
                    window.scrollTo(0, 0);
                }
            }, 500);
        },
        onChange(value) {
            this.$emit('updatePerPage', value);
        }
    },
    computed: {
        totalPage: function () {
            return Math.ceil(this.total / this.perPage);
        },
        from: function () {
            return (this.page - 1) * this.perPage + 1;
        },
        to: function () {
            let to = this.page * this.perPage;
            return to > this.total ? this.total : to;
        },
        pageList: function () {
            let pageList = [];

            for (let i = 1; i <= this.totalPage; i++) {
                let page = null;
                if (i === this.page) {
                    page = {
                        value: i,
                        class: 'active'
                    };
                } else if (i === 1 || i === this.totalPage || (i === 2 && this.page - i === 1) || (i - this.page === 1 && this.totalPage - i === 1)) {
                    page = {
                        value: i,
                        class: ''
                    };
                } else if ((i < this.page && i - 1 > 1) || (i > this.page && this.totalPage - i > 1)) {
                    if (pageList[pageList.length - 1].class !== 'dot') {
                        page = {
                            value: '...',
                            class: 'dot'
                        };
                    }
                }

                if (page) {
                    pageList.push(page);
                }
            }

            return pageList;
        }
    }
};
</script>
